import { Component } from '@angular/core';

@Component({
    selector: 'mon-overlay-spinner',
    templateUrl: './loading-spinner.html',
    styleUrls: ['./loading.scss'],
    standalone: false,
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class MonOverlaySpinner {}
